$(() => {
  $.post(loadNewsUrl, {}, (data) => {
    $('#news-list').html(data.html);
    $('#news-list a').attr('target', '_blank');
  });
});

$('.snippet').click(async function (e) {
  e.preventDefault();

  await navigator.clipboard.writeText($(this).find('#snippet-text').html());

  toastr.success(__('Print Snippet copied to clipboard'));
});
